import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="bg-background flex min-h-screen w-full items-center justify-center overflow-y-auto p-4">
      <div className="my-8 w-full sm:max-w-md">
        <Outlet />
      </div>
    </div>
  );
}
